module.exports = __webpack_public_path__ + "img/FONDOPANTTJ02.4f24cd5e.png";